import { BillsharkProviders } from '@core/models/interfaces/storage-data/billshark';
import { createActionGroup, props } from '@ngrx/store';

export const BillsharkProvidersActions = createActionGroup({
  source: 'BillsharkProviders',
  events: {
    'Load Billshark Providers Success': props<{
      billsharkProviders: BillsharkProviders;
    }>(),
  },
});
